import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Row, Col, Form, Button, Container } from 'react-bootstrap';
import Modal from "react-modal";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import SuccessPayment from './SuccessPayment';
import { useDispatch } from 'react-redux';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { setPaymentStatus } from '../features/AdSetupSlice';

const stripePromise = loadStripe('pk_test_51LLijESDK40ce5vjTdLu233ODHHQf6Ij8RdktRUZIgnLQ0SMaiS6z4PRLCHzplarl9oPr0s5uVsu7S83QhxvJWuW00jNu6LSTs');

const CheckoutForm = () => {

    const dispatch = useDispatch()
    const amount = useSelector((state: RootState) => state.campaign.amount);
    const id = useSelector((state: RootState) => state.campaign.id);
    const mediaType = useSelector((state: RootState) => state.campaign.mediaType);

    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(''); // Add this state variable


    const closeModal = () => {
        setShowModal(false);
    };


    const handleSubmit = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/pay/pay`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            // Add any necessary data you want to send to your backend
            body: JSON.stringify({ amount: amount }),
        });
        const { sessionId } = await response.json();
        console.log("Received sessionId:", sessionId);

        // Load Stripe
        const stripe = await stripePromise;

        // Redirect to Stripe Checkout
        const { error } = await stripe.redirectToCheckout({
            sessionId: sessionId
        });

        if (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const renderPayPalButton = () => {
            if (window.paypal) {
                const paypalButtonContainer = document.getElementById('paypal-button-container');
                if (paypalButtonContainer) {
                    window.paypal.Buttons({
                        createOrder: (data, actions) => {
                            return actions.order.create({
                                purchase_units: [{
                                    amount: {
                                        value: amount,
                                        currency: "USD"
                                    }
                                }]
                            });
                        },
                        onApprove: async (data, actions) => {
                            const order = await actions.order.capture();
                            console.log("Payment successful!", order);
                            setShowModal(true);
                            dispatch(setPaymentStatus(true))
                            setTimeout(() => {
                                dispatch(setPaymentStatus(false))
                                setShowModal(false);
                                navigate(`/addcampaigns?id=${id}&mediaType=${mediaType}`);
                            }, 3000);
                        },
                        style: {
                            layout: 'horizontal',
                            shape: "pill",
                            color: "silver",
                            tagline: "false",
                            height: 48,

                        }
                    }).render(paypalButtonContainer);
                } else {
                    console.error('Element #paypal-button-container does not exist');
                }
            }
        }
        setTimeout(renderPayPalButton, 0);
    }, [paymentMethod]);
    const handleRadioChange = (e) => {
        setPaymentMethod(e.target.value);
        if (e.target.value === "card") {
            handleSubmit();
        }
    };

    function formatNumber(value) {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }


    return (
        <Container className="mt-5">

            <Form autoComplete='off'>
                <div className='text-center'>
                    <h1>Total Amount</h1>
                    <p style={{ fontSize: "4.7rem" }}>${formatNumber(amount)}</p>
                    <h3 className="text-center mb-3 ms-2" style={{ color: "brown" }}>Choose your payment Method</h3>

                    <div className="mb-3">
                        <label style={{ fontSize: "18px" }}>
                            <input
                                type="radio"

                                className='mx-2'
                                name="paymentMethod"
                                value="card"
                                checked={paymentMethod === "card"}
                                onChange={handleRadioChange}
                            />

                            <span className='fw-bold text-primary' style={{ cursor: "pointer" }}>Credit/Debit Card</span>
                        </label>
                    </div>

                    <div className="mb-3">
                        <label style={{ fontSize: "18px" }}>
                            <input
                                className='mx-2'
                                type="radio"
                                name="paymentMethod"
                                value="paypal"
                                checked={paymentMethod === "paypal"}
                                onChange={handleRadioChange}
                            />
                            <span className='fw-bold text-danger' style={{ cursor: "pointer" }}>PayPal</span>
                        </label>
                    </div>
                    <div className='d-flex justify-content-center'>
                        {paymentMethod === 'paypal' && (
                            <div id="paypal-button-container" className='mt-4'></div>
                        )}
                    </div>
                </div>
            </Form>


            <Modal isOpen={showModal} onRequestClose={closeModal} style={{
                overlay: { zIndex: 2 }, content: {
                    width: '300px',
                    height: '200px',
                    margin: 'auto',
                    borderRadius: '30px',
                    padding: '20px'
                }
            }}>
                <SuccessPayment />
            </Modal>
        </Container >
    );
};

const Payment = () => {
    return (
        <Elements stripe={stripePromise}>
            <CheckoutForm />
        </Elements>
    );
};

export default Payment;
